import { CategoryConfig, StyleTypeIcon, BookmarkConfigItem, IconTypeMap } from "../../models/Config";
import { Category } from "../../models/Poi";
import { AbcFontOptions, BackgroundForm, TypeIcon } from "../ol-ext/fontsymbol/model";
import { AbcImageStyle, mapperFontOptions } from "../ol-ext/fontsymbol/AbcFontSymbol";
import { AbcIcons } from "../ol-ext/fontsymbol/private/mapicons";
import { Style } from "ol/style";

export const gen = 1;
export const iconGen: AbcIcons = "icon-flag";
const radius = 20;
const fontSize = 0.7;
const fontColor = "white";

export const iconDefault: AbcFontOptions = {
    backgroundForm: "poi",
    fill: "white",
    strokeColor: "blue",
    strokeWidth: 3,
    radius: radius,
    iconCss: iconGen,
    fontSize: fontSize,
    color: fontColor
}

export const styleType: StyleTypeIcon[] = [
    {
        type: "NORMAL",
        fill: "#59a978",
        strokeColor: "white",
        strokeWidth: 2,
        radius: radius,
        fontSize: fontSize,
        color: fontColor,
    },
    {
        type: "SELECTED",
        fill: "white",
        strokeColor: "#59a978",
        strokeWidth: 3,
        radius: radius,
        fontSize: fontSize,
        color: "#3E7754"
    },
    {
        type: "HOVERED",
        fill: "#9BCBAE",
        strokeColor: "white",
        strokeWidth: 2,
        radius: radius,
        fontSize: fontSize,
        color: "#3E7754"
    },
    {
        type: "EDIT",
        fill: "#f7724d",
        strokeColor: "white",
        strokeWidth: 2,
        radius: radius,
        fontSize: fontSize,
        color: fontColor
    }
]

export const currentCategory: CategoryConfig[] = [
    {
        "image_url": "images/portal/flag.png",
        "backgroundForm": "bubble",
        "icon": "icon-flag"
    },
    {
        "image_url": "images/fam/map_add.png",
        "backgroundForm": "bubble",
        "icon": "icon-map"
    }
]

export default class IconCategory {

    readonly gen = 1;
    readonly iconGen: AbcIcons = "icon-flag";
    readonly radius = 20;
    readonly fontSize = 0.7;
    readonly fontColor = "white";

    readonly backgroundDefault: BackgroundForm = "bubble";
    readonly abcIconDefault: AbcIcons = "icon-flag";

    categoryMap: { [key: string]: BookmarkConfigItem[] } = {};
    iconsTypeMap: { [key: string]: IconTypeMap } = {};

    initialize = false;

    constructor() {
        currentCategory.forEach((catConfig) => {
            this.categoryMap[catConfig.image_url] = [];
            styleType.forEach(p => this.categoryMap[catConfig.image_url].push({
                typeIcon: p.type as TypeIcon,
                icon: {
                    backgroundForm: catConfig.backgroundForm,
                    fill: p.fill,
                    strokeColor: p.strokeColor,
                    strokeWidth: p.strokeWidth,
                    radius: this.radius,
                    iconCss: catConfig.icon,
                    fontSize: p.fontSize,
                    color: p.color
                }
            }));

            const styleIcons = new Map();
            styleType.forEach((st) => {
                styleIcons.set(st.type, this.buildGeneric(catConfig.image_url, st.type))
            })
            this.iconsTypeMap[catConfig.image_url] = {
                id: catConfig.image_url,
                icons: styleIcons
            }
        })
    }

    public getIconCat(cat: Category | null | undefined) {
        let iconR = `abc-${this.iconGen}`;
        if (cat && this.categoryMap) {
            const c = this.categoryMap[cat.image_url];
            if (c && c.length > 0) {
                iconR = `abc-${c[0].icon.iconCss}`;
            }
        }
        return iconR;
    }

    public getIconCatId(urlImage: string | null | undefined) {
        let iconR = `abc-${this.iconGen}`;
        if (urlImage) {
            const c = this.categoryMap[urlImage];
            if (c && c.length > 0) {
                iconR = `abc-${c[0].icon.iconCss}`;
            }
        }
        return iconR;
    }

    public buildGeneric(url?: string, type = "NORMAL"): Style {
        let options;
        if (url) {
            if (this.categoryMap[url]) {
                options = this.categoryMap[url].find(p => p.typeIcon == type)?.icon || iconDefault
            } else {
                options = iconDefault;
            }

        } else {
            options = iconDefault;
        }
        return new Style({
            image: new AbcImageStyle(mapperFontOptions(options))
        });
    }

    public getMapIcon(url: string, typeIcon: TypeIcon = "NORMAL"): Style | undefined {
        return this.iconsTypeMap[url]?.icons.get(typeIcon);
    }
}
